// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PhoneFillSvg from '@rsuite/icon-font/lib/device/PhoneFill';
var PhoneFill = createSvgIcon({
  as: PhoneFillSvg,
  ariaLabel: 'phone fill',
  category: 'device',
  displayName: 'PhoneFill'
});
export default PhoneFill;